import "./Images.css";


function Images(prop) {

  return <img className="diary-shot" src={prop.imageSRC} alt="" loading="lazy"/>;
}

export default Images;
